export default class ApplicationtypeSelect extends HTMLDivElement {

    constructor() {
        super();
    }

    get studentRadio() {
        return this.querySelector("[data-applicationtype-select='student']");
    }

    get memberRadio() {
        return this.querySelector("[data-applicationtype-select='member']");
    }
    
    get studentInformation() {
        return this.querySelector("[data-applicationtype-select='information']");
    }

    get step2Tab() {
        return document.querySelector("[data-step='2']");
    }

    get step2TabHeading() {
        return this.step2Tab.querySelector(".step-indicator-heading");
    }
 
    connectedCallback() {
        this.studentRadio.addEventListener("change", (event) => {
            if (event.target.value) {
                this.studentInformation.style.display = "flex";
                this.step2TabHeading.innerHTML = this.step2Tab.dataset.switchheading2;
            }
        });

        this.memberRadio.addEventListener("change", (event) => {
            if (event.target.value) {
                this.studentInformation.style.display = "none";
                this.step2TabHeading.innerHTML = this.step2Tab.dataset.switchheading1;
            }
        });      
    }
}

customElements.define('applicationtype-select', ApplicationtypeSelect, { extends: "div" });